import { useContext } from 'react';

import type { ErrorContextValues } from '../../context/error-context/error-context';
import { ErrorContext } from '../../context/error-context/error-context';

export const useErrorContext = (): ErrorContextValues => {
  const context = useContext(ErrorContext);

  if (!context) {
    throw new Error('No provider found for Error Context');
  }

  return context;
};
